export function customScroll() {
    $(document).ready(function () {
        jcf.setOptions("Scrollable", {
            handleResize: false,
            alwaysShowScrollbars: false,
            alwaysPreventMouseWheel: true
        });
        jcf.replaceAll();
        $(window).on("load resize", function () {
            jcf.replaceAll();
        });
    });
};


// WEBPACK FOOTER //
// ./assets/js/modules/customScroll.js